(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticketrealtime', {
            parent: 'entity',
            url: '/ticketrealtime?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ticketrealtime.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtimes.html',
                    controller: 'TicketrealtimeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketrealtime');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticketrealtime-detail', {
            parent: 'ticketrealtime',
            url: '/ticketrealtime/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ticketrealtime.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-detail.html',
                    controller: 'TicketrealtimeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketrealtime');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ticketrealtime', function($stateParams, Ticketrealtime) {
                    return Ticketrealtime.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticketrealtime',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticketrealtime-detail.edit', {
            parent: 'ticketrealtime-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-dialog.html',
                    controller: 'TicketrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticketrealtime', function(Ticketrealtime) {
                            return Ticketrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticketrealtime.new', {
            parent: 'ticketrealtime',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-dialog.html',
                    controller: 'TicketrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                ip: null,
                                nroticket: null,
                                esncredito: null,
                                montototal: null,
                                cantitems: null,
                                cliente: null,
                                mediodepago: null,
                                nrolocal: null,
                                flagproceso: null,
                                fechaproceso: null,
                                fechaenvio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticketrealtime', null, { reload: 'ticketrealtime' });
                }, function() {
                    $state.go('ticketrealtime');
                });
            }]
        })
        .state('ticketrealtime.edit', {
            parent: 'ticketrealtime',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-dialog.html',
                    controller: 'TicketrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticketrealtime', function(Ticketrealtime) {
                            return Ticketrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticketrealtime', null, { reload: 'ticketrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticketrealtime.delete', {
            parent: 'ticketrealtime',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-delete-dialog.html',
                    controller: 'TicketrealtimeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ticketrealtime', function(Ticketrealtime) {
                            return Ticketrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticketrealtime', null, { reload: 'ticketrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
